// Create a sanity image url builder with optimization
// https://cdn.sanity.io/images/<project id>/production/<id>?rect=<rect>&w=<width>&h=<height>&auto=format&q=<quality>
// @param {id} id - the id of the image
// @param {width} width - the width of the image
// @param {height} height - the height of the image
// @param {cropData} cropData - the crop data of the image
// @param {options} options - optimization options (quality, format, fit)

const urlImageBuilder = (id, width, height, cropData, options = {}) => {
  const {
    quality = 75,
    format = 'format',
    fit = 'max',
  } = options;

  const getPixelCropData = (cropData) => {

    const width = cropData.width;
    const height = cropData.height;
    const left = percentToPx(cropData.left * 100, width);
    const top = percentToPx(cropData.top * 100, height);
    const right = percentToPx(cropData.right * 100, width);
    const bottom = percentToPx(cropData.bottom * 100, height);



    // if value is not number return null to prevent error
    if (isNaN(top)) {
        return null;
    } else {
        return `${parseInt(left)},${parseInt(top)},${
            parseInt(width) - parseInt(left) - parseInt(right) - 1
          },${parseInt(height) - parseInt(top) - parseInt(bottom) - 1}`;
    }

  };

  const percentToPx = (percent, dimension) => {
    return (percent / 100) * dimension;
  };

  // Build query parameters array
  const params = [];
  
  // Add crop if exists
  const crop = getPixelCropData(cropData);
  if (crop) {
    params.push(`rect=${crop}`);
  }
  
  // Add dimensions
  if (width) params.push(`w=${width}`);
  if (height) params.push(`h=${height}`);
  
  // Add optimizations
  params.push(`auto=${format}`);
  params.push(`q=${quality}`);
  params.push(`fit=${fit}`);
  
  const query = params.length > 0 ? `?${params.join('&')}` : '';

  return `https://cdn.sanity.io/${id}${query}`;
};

export default urlImageBuilder;
